module.exports = __webpack_public_path__ + "img/message-question.411dca48.svg";